import { render } from "./SaiyoPage.vue?vue&type=template&id=fdd9771c&scoped=true"
import script from "./SaiyoPage.vue?vue&type=script&lang=js"
export * from "./SaiyoPage.vue?vue&type=script&lang=js"

import "./SaiyoPage.vue?vue&type=style&index=0&id=fdd9771c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd9771c"]])

export default __exports__